import { useMemo } from "react";
import { SensorStatus } from "enums/Sensor";
import Dropdown from "components/Dropdowns/Dropdown/Dropdown";
import { IDropdownOption } from "interfaces/Common";
import { formatSensorStatusLabel } from "helpers/SensorHelper";

interface SensorStatusDropdownProps {
  label?: string;
  useInputFieldStyle?: boolean;
  hideClearButton?: boolean;
  disabled?: boolean;
  selected: SensorStatus | undefined;
  onChange: (value: SensorStatus | undefined) => void;
}

const ANY_STATUS_VALUE = -2; // Use -2 to avoid conflict with MenuOption.Unselected (-1)

const SensorStatusDropdown = ({
  label = "Select sensor status",
  ...rest
}: SensorStatusDropdownProps) => {
  const options = useMemo(
    (): IDropdownOption<number>[] =>
      [
        { value: ANY_STATUS_VALUE, label: "Any" },
        ...[
          SensorStatus.Unassigned,
          SensorStatus.InWarehouse,
          SensorStatus.ShippedToCustomer,
          SensorStatus.AtCustomer,
          SensorStatus.ReturnedToWarehouse,
          SensorStatus.AssignedInternal,
          SensorStatus.AssignedRemote,
          SensorStatus.AssignedToClinic,
          SensorStatus.AssignedForInClinic,
          SensorStatus.Damaged,
          SensorStatus.Lost,
        ].map((x) => ({ value: x, label: formatSensorStatusLabel(x) })),
      ],
    []
  );

  return (
    <div className="min-w-[270px]">
      <Dropdown 
        label={label} 
        options={options} 
        {...rest}
        selected={rest.selected === undefined ? ANY_STATUS_VALUE : rest.selected}
        onChange={(value) => rest.onChange(value === ANY_STATUS_VALUE ? undefined : value as SensorStatus)}
      />
    </div>
  );
};

export default SensorStatusDropdown;
